export var MaskType;
(function (MaskType) {
    MaskType["asterisk"] = "*";
    MaskType["dot"] = "\u2022";
})(MaskType || (MaskType = {}));
